export const handleDropAccepted = ({
    acceptedFiles,
    setAcceptedFiles,
    handleClearErrors,
    setMaxFiles,
    maxFiles
}) => {
    handleClearErrors();

    setMaxFiles(maxFiles - acceptedFiles.length);

    setAcceptedFiles(prevFiles =>
        acceptedFiles.reduce(
            (acc, file) => [
                ...acc,
                {
                    preview: URL.createObjectURL(file), // creates file preview
                    lastModified: file.lastModified,
                    lastModifiedDate: file.lastModifiedDate,
                    name: file.name,
                    size: file.size,
                    type: file.type,
                    warnings: {
                        // message: "Disallowed words will be removed."
                    }, // todo: this will be for the BE response, we dont know what it looks like yet
                    errors: {
                        //message: "Add release to submit"
                    } // todo: this will be for the BE response, we dont know what it looks like yet
                }
            ],
            prevFiles
        )
    );
};

export const handleDropRejected = ({
    fileRejections,
    setRejectedFiles,
    setRejectedFileErrors
}) => {
    setRejectedFiles(prevFiles =>
        fileRejections.reduce(
            (acc, rejected) => [
                ...acc,
                {
                    preview: URL.createObjectURL(rejected.file), // creates file preview
                    lastModified: rejected.file.lastModified,
                    lastModifiedDate: rejected.file.lastModifiedDate,
                    name: rejected.file.name,
                    size: rejected.file.size,
                    type: rejected.file.type,
                    errors: rejected.errors
                }
            ],
            prevFiles
        )
    );

    setRejectedFileErrors(
        fileRejections.map((rejectedFile, index) => {
            return {
                index: index,
                name: rejectedFile.file.name,
                size: rejectedFile.file.size,
                errors: rejectedFile.errors
            };
        })
    );
};
